/**
 * External dependencies
 */
import { Reducer } from 'redux';
import produce from 'immer';

/**
 * Internal dependencies
 */
import Service from '@naruto/bgdcms//src/reducers/stores/service';
import SERVICE_ACTION from '@naruto/bgdcms//src/reducers/cores/service/events';
import { CreateServiceReducerParams, ServiceActionTypes } from './types';

export function createServiceReducer(params: CreateServiceReducerParams): Reducer<Service, ServiceActionTypes> {
  return (state = params.initialState, action: ServiceActionTypes): Service =>
    produce(state, _draft => {
      const draft = _draft;
      switch (action.type) {
        case SERVICE_ACTION.SET_SERVICE_INITIALIZE:
          draft.initialize();
          break;
        case SERVICE_ACTION.SET_SERVICE_LIST:
          draft.updateServiceList(action.list, action.condition);
          break;
        case SERVICE_ACTION.SET_SERVICE_INFO:
          draft.updateServiceInfo(action.serviceID, action.serviceInfo);
          break;
        default:
          break;
      }
    });
}
